import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { CardLayoutInline } from './style';
const CardInfoRow = ({ Icon, value }) => {
    if (!value)
        return _jsx(_Fragment, {});
    return (_jsxs(CardLayoutInline, { children: [_jsx(Icon, { size: 14, style: { flexShrink: 0 } }), _jsx(Typography, { elementTheme: "overline", ellipsis: true, overflow: true, children: value })] }));
};
export default CardInfoRow;
